import * as React from 'react';
import { TicketListData } from '../types';
import { useStatusLabel, widgetDate } from './widgetFormat';

type Props = {
  data: TicketListData;
};

const TicketListWidget: React.FC<React.PropsWithChildren<Props>> = ({
  data,
}) => {
  const statusLabel = useStatusLabel();
  if (data.items.length === 0) {
    return null;
  }
  return (
    <div className="ai-chat-widget ai-chat-widget-ticket-list">
      {data.items.map((item, idx) => (
        <div key={idx} className="ai-chat-widget-ticket-list-row">
          <div className="ai-chat-widget-ticket-list-main">
            <span className="ai-chat-widget-ticket-list-subject">
              {item.subject || '—'}
            </span>
            <span className="ai-chat-widget-ticket-list-date">
              {widgetDate(item.date, item.dateLabel)}
            </span>
          </div>
          <span
            className={`ai-chat-widget-status-pill ai-chat-widget-status-pill--${item.status}`}>
            {statusLabel(item.statusLabel)}
          </span>
        </div>
      ))}
    </div>
  );
};

export default TicketListWidget;
